import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { auth } from '../../state/auth'
import { isDefined, isTokenValid } from '../../utils'
import { AutomaticallyLogoutedDialog, NoAccessDialog } from './widgets/Login'

export const AuthorizationProvider = (props) => {
  const dispatch = useDispatch()
  const authorizationTokenCookie = Cookies.get('X_CAT_TOKEN')

  if (isDefined(authorizationTokenCookie)) {
    Cookies.remove('X_CAT_TOKEN')

    if (isTokenValid(authorizationTokenCookie)) {
      const { nick, user, attendee, avatar_url } = jwtDecode(authorizationTokenCookie)
      dispatch(auth({ authToken: authorizationTokenCookie, profile: { nick, user, attendee, avatar_url } }))
    }
  }

  return props.children
}

export const AuthorizationGate = (props) => {
  const { expired, profile, authToken } = useSelector(state => state?.auth)
  const authorized = isTokenValid(authToken) && isDefined(profile)
  const { children, redirect } = props
  const navigate = useNavigate()

  if (isDefined(redirect) && !authorized) {
    navigate(redirect)
  }

  if (expired) {
    return <AutomaticallyLogoutedDialog />
  } else if (!authorized) {
    return <NoAccessDialog />
  } else {
    return children
  }
}
